import Konva from 'konva';
import { Line } from 'react-konva';
import { GUTTER_LINE_CONFIG } from './constant';
import { useDispatch } from 'react-redux';
import { updateRemoveGutterLine } from 'store/slices/RoofToolLinesSlice';

type LineProps = Konva.LineConfig & {
	segmentId: string;
	gutterLine: {
		coords: number[][];
    id: string | number ;
	}
	hitStroke?: number;
}

export default function TempGutterLines(props: LineProps) {

	const { segmentId, gutterLine, hitStroke, ...lineConfig } = props;
	const dispatch = useDispatch();

	function handleHoverOnGutterLine(e: Konva.KonvaEventObject<PointerEvent>, event: 'ENTER'|'OUT'){
		e.cancelBubble = true;
		const line = e.target as Konva.Line;
		const container = line?.getStage()?.container();

		if (container) container.style.cursor = event === 'ENTER' ? 'pointer' : 'default';
		line.strokeWidth(event === 'ENTER' ? GUTTER_LINE_CONFIG.strokeWidth + 2 : GUTTER_LINE_CONFIG.strokeWidth);
	}
	return(
		<Line
			name={`gutter-line-${segmentId}-${gutterLine.id}`}
			{...lineConfig}
			// strokeScaleEnabled={false}
			stroke={GUTTER_LINE_CONFIG.color}
			strokeWidth={GUTTER_LINE_CONFIG.strokeWidth}
			hitStrokeWidth={hitStroke}
			onPointerClick={() => {
				dispatch(updateRemoveGutterLine({ id: gutterLine.id, facetId:segmentId }));
			}}
			onPointerEnter={(e) => handleHoverOnGutterLine(e, 'ENTER')}
			onPointerOut={(e) => handleHoverOnGutterLine(e, 'OUT')}
		/>
	);
	
}